import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  disableFlexConfig,
  saveFlexConfig,
  syncFlexNow,
  testFlexConnection,
  type FlexConfigInput,
  type FlexTestInput,
} from '../../lib/api/endpoints';
import { importKeys } from '../imports/queries';
import { notificationKeys } from '../notifications/queries';
import { positionKeys } from '../positions/queries';

import { flexKeys } from './queries';

export function useSaveFlexConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: FlexConfigInput) => saveFlexConfig(input),
    onSuccess: (config) => {
      queryClient.setQueryData(flexKeys.config(config.accountId), config);
      void queryClient.invalidateQueries({ queryKey: flexKeys.all });
    },
  });
}

export function useDisableFlexConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (accountId: string) => disableFlexConfig(accountId),
    onSuccess: (_result, accountId) => {
      void queryClient.invalidateQueries({ queryKey: flexKeys.config(accountId) });
    },
  });
}

export function useTestFlexConnection() {
  return useMutation({
    mutationFn: (input: FlexTestInput) => testFlexConnection(input),
  });
}

export function useSyncFlexNow() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (accountId: string) => syncFlexNow(accountId),
    onSettled: (_result, _error, accountId) => {
      void queryClient.invalidateQueries({ queryKey: flexKeys.config(accountId) });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: importKeys.all });
      void queryClient.invalidateQueries({ queryKey: positionKeys.all });
      void queryClient.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}
